import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "panel__text-wrapper" }
const _hoisted_3 = { class: "panel__title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "panel__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        (_ctx.icon)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              class: "panel__icon",
              size: 44
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.icon), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("p", {
        class: "panel__description",
        innerHTML: _ctx.description
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}